import { Link, useNavigate } from "react-router-dom";
import DashBoardHead from '../DashBoard/DashBoardHead';


function EndUserDetail() {

    const navigate=useNavigate()

  return (
    <div>

<div className='ecom-user-detail-header'>
<DashBoardHead/>
</div>


<div className='ecom-user-details-div'>
<div className='ecom-user-back'><Link to='/admin/allEndUsers'><p>Back</p></Link></div>

     <div className='ecom-user-detail-container'>  
        <div className='ecom-user-detail-main'>
            <div className='ecom-user-detail-section'>
                <div className='ecom-user-left-section-detail'>
                    <div>
                        <p>Type: <b> Electrician</b></p>
                        <br/>
                        <p>Degree:<b></b></p>
                        <p>Age:</p>
                        <p>Address:</p>
                        <p>City:</p>
                        <p>State:</p>
                        <p>Pin Code:</p>
                        <p>Documents</p>
                    </div>
                </div>
                <div className='ecom-user-right-section-detail'>
                    <div className='ecom-user-right-profile'>

                    </div>
                    <div className='ecom-user-right-profile-detail'>
                        <h3>Arun Sharma</h3>
                        <h3>+91 012345678</h3>
                        <h3>arun@gmail.com</h3>
                    </div>

                </div>
            </div>



            <div className='ecom-user-detail-btns'>
                <button className='ecom-user-discard-btn' onClick={()=>navigate('/admin/allEndUsers')}>Discard</button>
                <button className='ecom-user-approve-btn'>Approve</button>
            </div>
        </div>
     </div>
</div>
    </div>
  )
}

export default EndUserDetail;

